var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M1 1L11.2105 12L21 1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }